
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { BoolEnum } from "src/app/core/enums/bool-enum";

export class ImportEntitiesListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Import List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'entityType',
                title: 'Type',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "70px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: `${EntityTypeEnum.Client}`, return: 'coloredTextArea blue' },
                        { case: `${EntityTypeEnum.Account}`, return: 'coloredTextArea orange' },
                        { case: undefined, return: 'coloredTextArea purple' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: `${EntityTypeEnum.Client}`, return: 'Client' },
                        { case: `${EntityTypeEnum.Account}`, return: 'Contact' },
                        { case: undefined, return: 'Unknown' }
                    ]
                }
            },
            {
                dataFieldName: 'createdDate',
                title: 'Created Date',
                sortable: new SortByValuesModel('createdDate'),
                visible: 'true',
                order: 2,
                width: "110px",
                type: ColumnTypeEnum.Date,
            },

            {
                dataFieldName: 'source',
                title: 'Source',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "100px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'isProcessing',
                title: 'Status',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "150px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: undefined, return: 'coloredTextArea purple' },
                        { case: `${BoolEnum.True}`, return: 'coloredTextArea blue' },
                        { case: `${BoolEnum.False}`, return: 'coloredTextArea purple' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: undefined, return: 'Awaiting Processing' },
                        { case: `${BoolEnum.True}`, return: 'Processed' },
                        { case: `${BoolEnum.False}`, return: 'Awaiting Processing' }
                    ]
                }
            },
            {
                dataFieldName: 'models',
                title: 'Details',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 5,
                width: "350px",
                type: ColumnTypeEnum.ArrayPhotoModel,
                arrayModels: [
                    { entityType: `${EntityTypeEnum.Client}`, model: { mainDataFieldName: 'fullName', } },
                    { entityType: `${EntityTypeEnum.Account}`, model: { mainDataFieldName: 'fullName', } }
                ]
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 6,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [
            {
                label: "type",
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Type`, $localize`:@@:Select Type`, undefined, true),
                    new NgSelectListModel(EntityTypeEnum.Client, $localize`:@@:Client`, $localize`:@@:Client`),
                    new NgSelectListModel(EntityTypeEnum.Account, $localize`:@@:Contact`, $localize`:@@:Contact`),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]

        this.actions = [
            {
                visible: 'true',
                label: 'View',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-eye-fill',
                inDropdown: false,
                inList: true
            },
            {
                visible: 'true',
                label: 'Import',
                actionId: ActionIdEnum.Import,
                icon: 'ri-file-download-line',
                inDropdown: true,
                inList: false
            },
        ]

        this.buttons = [
            {
                visible: 'true',
                label: "Actions",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: 'Import',
                        value: ButtonIdEnum.Import,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                ]
            },

        ]
    }
}